import React, { useRef, useEffect, useState, forwardRef } from "react";
import PushPinIcon from "@mui/icons-material/PushPin";
import "./ResponseQueryOptions.scss";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import PinningPopup from "../history/PinningPopup";
import { ArrowDownToLine, FileDown } from "lucide-react";

// const optionsItems = [
//   { id: 1, label: "Pin", icon: <PushPinIcon /> },
//   { id: 2, label: "Download Pdf", icon: <DownloadIcon /> },
// ];

const Options = ({
  setOpenOptions,
  printPDF,
  index,
  messageID,
  isPinned,
  handlePin,
  pinError,
  item,
  handleExpandClick,
  pinLoading,
  exportToPDF,
  chartId,
  title,
  score,
  backgroundColor
}) => {
  const [open, setOpen] = useState(false);
  const optionsRef = useRef(null);
  const handleClickOutside = (event) => {
    if (optionsRef.current && !optionsRef.current.contains(event.target)) {
      setOpenOptions(false);
    }
  };

  useEffect(() => {
    if (!open) {
      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [open]);

  useEffect(() => {
    if (!pinLoading) {
      setOpen(false);
    }
  }, [pinLoading]);

  return (
    <div
      id="history-query-options"
      className={`${"options-container"}
      }`}
      ref={optionsRef}
    >
      <ul className="options-list">
        <li onClick={() => setOpen(true)} className="list-item">
          <div className="item-container">
            <PushPinIcon className={`${isPinned ? "active-pin" : ""}`} />
            <p className="setting-txt pl-3">{isPinned ? "Unpin" : "Pin"}</p>
          </div>
        </li>
        {item.status && (
          <li
            className="list-item"
            onClick={() => {
              handleExpandClick(item);
              setOpenOptions(false);
            }}
          >
            <div className="item-container">
              <OpenInFullIcon />
              <p className="setting-txt pl-3">Expand</p>
            </div>
         
          </li>
        )}

            <li
            className="list-item"
            onClick={() => {
              exportToPDF(chartId, title);
            }}
          >
            <div className="item-container">
            <ArrowDownToLine />             
            
             <p className="setting-txt pl-3">Download</p>
            </div>
         
          </li>


          <li
            className="list-item"
          
          >
            <div className="item-container">
             <span style={{
                    backgroundColor: backgroundColor,
                    color:
                      parseFloat(score).toFixed(2) > 0.75
                        ? "white"
                        : parseFloat(score).toFixed(2) > 0.5
                        ? "black"
                        : "white",
                    padding: "5px",
                    borderRadius: "6px",
                    fontWeight: "600",
                    fontSize:"12px"
                  }}>
            {parseFloat(score).toFixed(2)}
             </span>
              <p className="setting-txt">Conf. Score </p>
            </div>
         
          </li>

        
      </ul>
      {open && (
        <PinningPopup
          open={open}
          setOpen={setOpen}
          messageID={messageID}
          pinLoading={pinLoading}
          handlePin={handlePin}
          isPinned={isPinned}
          item={item}
        />
      )}
    </div>
  );
};

export default Options;
